import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import { getLocalStorageWithExpiry } from '../assets/js/localStorage';

// 注册 vue-router
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
};

// 引入组件
import Home from '@/page/Home.vue';
import Main from '@/views/Main.vue';

// 配置路由规则
const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
		redirect: 'homeContent',
		children: [
			{
				path: 'homeContent',
				name: 'homeContent',
				component: () => import('@/components/HomeContent.vue'),
			},
			{
				path: 'brandContent',
				name: 'brandContent',
				component: () => import('../components/brandContent.vue'),
			},
			{
				path: 'memberContent',
				name: 'memberContent',
				component: () => import('../components/MemberContent.vue'),
			},
			{
				path: 'brandArticle',
				name: 'brandArticle',
				component: () => import('../components/BcArticleDetail.vue'),
			},
			{
				path: 'nav',
				name: 'nav', // 参数：typea, typeb
				component: () => import('../components/Nav.vue'), // 懒加载写法, 访问该组件时再获取
				props: true,
				children: [
					{
						path: 'articleList',
						name: 'articleList',
						component: () => import('../components/ArticleList.vue'),
					},
					{
						path: 'article',
						name: 'article', // 参数：id
						component: () => import('../components/Article.vue'),
					},
					{
						path: 'bcPdf',
						name: 'bcPdf',
						component: () => import('../components/BcPdf.vue'),
					},
				],
			},
			{
				path: 'detail',
				name: 'detail', // 参数：title
				component: () => import('../components/Detail.vue'),
				children: [
					{
						path: 'xhjs',
						name: 'xhjs',
						component: () => import('../components/Xhjs.vue'),
					},
					{
						path: 'xhzc',
						name: 'xhzc',
						component: () => import('../components/Xhzc.vue'),
					},
					{
						path: 'fzjg',
						name: 'fzjg',
						component: () => import('../components/Fzjg.vue'),
					},
					{
						path: 'msc',
						name: 'msc',
						component: () => import('../components/Msc.vue'),
					},
					{
						path: 'fwqd',
						name: 'fwqd',
						component: () => import('../components/Fwqd.vue'),
					},
					{
						path: 'hyxx',
						name: 'hyxx',
						component: () => import('../components/Hyxx.vue'),
					},
					{
						path: 'memberDetail',
						name: 'memberDetail', // 参数：memberType，memberId
						component: () => import('../components/MemberDetail.vue'),
					},
				],
			},
		],
	},
	{
		path: '/construction',
		name: 'construction',
		component: () => import('../page/Construction.vue'),
	},
	{
		path: '/main',
		name: 'main',
		component: Main,
		// redirect: 'index',
		children: [
			{
				path: 'index',
				name: 'index',
				component: () => import('@/views/index.vue'),
			},
			{
				path: 'step1',
				name: 'step1',
				component: () => import('@/views/stepPage/stepOne.vue'),
			},
			{
				path: 'step2',
				name: 'step2',
				component: () => import('@/views/stepPage/stepTwo.vue'),
			},
			{
				path: 'step3',
				name: 'step3',
				component: () => import('@/views/stepPage/stepThree.vue'),
			},
			{
				path: 'step4',
				name: 'step4',
				component: () => import('@/views/stepPage/stepFour.vue'),
			},
			{
				path: 'step5',
				name: 'step5',
				component: () => import('@/views/stepPage/stepFive.vue'),
			},
			{
				path: 'step6',
				name: 'step6',
				component: () => import('@/views/stepPage/stepSix.vue'),
			},
		],
	},
];

// 创建 router 实例
const router = new VueRouter({
	// mode: 'hash',
	mode: 'history', // 启用 History 模式
	base: process.env.VUE_APP_NAME,
	routes,
});

// 在Vue应用初始化之前
router.beforeEach((to, from, next) => {
	const token = getLocalStorageWithExpiry('token');
	if (token) {
		store.state.token = token;
	}
	// if (to.path === '/') {
	// 	next({ name: 'home' });
	// } else if (to.path === '/main') {
	// 	next({ name: 'main' });
	// } else {
	// 	next();
	// }
	next();
});

// 导出 router 实例
export default router;
